import * as Edge from './../core';

export default abstract class OrganizationTypeService {
	public static isEvent(organization?: Edge.Models.Organization): boolean {
		if (!organization || !organization.organizationType) return false;
		return organization.organizationType.id === Edge.Models.OrganizationTypeId.Event;
	}
}
